var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-module-home"},[_c('div',{staticClass:"home-content py20"},_vm._l((_vm.slides),function(slide){return _c('div',{staticClass:"mb22"},[_c('ItemHomeSlideCard',{attrs:{"slide":slide}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }